import { createFileRoute } from '@tanstack/react-router';
import { SignedOutPage, StandaloneHeader } from '@hlt/web-kit/shell';

/** `/signed-out?next=`: hop of a sign-out that started in another app; clears this app's drafts. */
export const Route = createFileRoute('/signed-out')({
    validateSearch: (search: Record<string, unknown>): { next?: string } =>
        typeof search.next === 'string' ? { next: search.next } : {},
    component: function SignedOutRoute() {
        const { next } = Route.useSearch();
        return (
            <div className="flex min-h-dvh flex-col bg-background">
                <StandaloneHeader width="max-w-[440px]" />
                <main
                    id="main"
                    className="mx-auto flex w-full max-w-[440px] flex-1 flex-col justify-center gap-6 px-4 py-10"
                >
                    <div className="rounded-[8px] border border-border bg-card p-5 md:p-8">
                        <SignedOutPage next={next} />
                    </div>
                </main>
            </div>
        );
    },
});
